import RightContent from '@/components/RightContent/RightContent';
import { LinkOutlined } from '@ant-design/icons';
import { RunTimeLayoutConfig, useModel } from '@umijs/max';
import { message } from 'antd';
import { fetchUserInfo } from './services/base';
const isDev = process.env.NODE_ENV === 'development';
import * as auth from './utils/auth';
// 运行时配置

// 全局初始化数据配置，用于 Layout 用户信息和权限初始化
// 更多信息见文档：https://next.umijs.org/docs/api/runtime-config#getinitialstate
export async function getInitialState(): Promise<InitialGlobalState> {
  let config = {
    userinfo: {}
  } as InitialGlobalState;

  try {
    let { code, data } = await fetchUserInfo<TUserinfo>()

    if (code === 200) {
      Object.assign(config.userinfo, data)
    } else {
      auth.logout()
    }

  } catch (error) {
    message.error('用户信息获取失败')
  }

  return config;
}

export const layout: RunTimeLayoutConfig = () => {
  let { initialState } = useModel('@@initialState')

  let prodLink = []

  if (initialState?.userinfo.email) {
    prodLink.push((
      <a
        key='企业邮箱'
        href='https://qiye.aliyun.com/'
        target='_blank'
        rel='noreferrer'
      >
        <LinkOutlined />
        <span>{initialState.userinfo.email}</span>
      </a>
    ))
  }

  return {
    logo: 'https://nanyue-website.oss-cn-shenzhen.aliyuncs.com/image/66798d122d961e6a0b2b5de7982828a8.png',
    title: '后台管理系统',
    menu: {
      locale: false,
    },
    layout: 'mix',
    locale: 'zh-CN',
    rightContentRender: () => <RightContent />,
    theme: 'dark',
    // bgLayoutImgList: [
    //   {
    //     src: 'https://img.playlarp.com/36f36f858710535478cbcc51e7dd0708.png',
    //     left: 85,
    //     bottom: 100,
    //     height: '303px',
    //   },
    //   {
    //     src: 'https://img.playlarp.com/36f36f858710535478cbcc51e7dd0708.png',
    //     bottom: -68,
    //     right: -45,
    //     height: '303px',
    //   },
    //   {
    //     src: 'https://img.playlarp.com/13e47493706060dd119cd75191e421ea.png',
    //     bottom: 0,
    //     left: 0,
    //     width: '331px',
    //   },
    // ],
    // 菜单左侧的开发文档链接, 只在开发模式下会展示, build后会自动剔除
    links: !isDev
      ? [
        <a
          key='AntDesign文档'
          href='https://ant.design/index-cn'
          target='_blank'
          rel='noreferrer'
        >
          <LinkOutlined />
          <span>AntDesign文档</span>
        </a>,
        <a
          key='AntDesignPro文档'
          href='https://beta-pro.ant.design/index-cn'
          target='_blank'
          rel='noreferrer'
        >
          <LinkOutlined />
          <span>AntDesignPro文档</span>
        </a>,
        <a
          key='ProComponents文档'
          href='https://procomponents.ant.design/'
          target='_blank'
          rel='noreferrer'
        >
          <LinkOutlined />
          <span>ProComponents文档</span>
        </a>,
        <a
          key='umijs文档'
          href='https://umijs.org/'
          target='_blank'
          rel='noreferrer'
        >
          <LinkOutlined />
          <span>umijs文档</span>
        </a>,
        <a
          key='antd chart文档'
          href='https://charts.ant.design/'
          target='_blank'
          rel='noreferrer'
        >
          <LinkOutlined />
          <span>antd chart文档</span>
        </a>,
        <a
          key='IconFont'
          href='https://www.iconfont.cn/'
          target='_blank'
          rel='noreferrer'
        >
          <LinkOutlined />
          <span>IconFont</span>
        </a>,
      ]
      : prodLink,
  };
};
